import {useState} from 'react'
import {useLocation} from 'react-router-dom'
import {clearInputError} from '../../../_metronic/helpers'
import {handleInputChange, handleOtherInputChange} from '../../CommonFunction'
import CustomFileInput from '../../components/CustomInput/CustomFileInput'
import CustomNumberInput from '../../components/CustomInput/CustomNumberInput'
import CustomRadioInput from '../../components/CustomInput/CustomRadioInput'
import CustomTextInput from '../../components/CustomInput/CustomTextInput'
import {PartnerMasterInput} from '../../types/AdminModuleTypes'
import {InputErrorType, SelectValueType} from '../../types/OtherTypes'

const PartnerForm = (props: {
  formField: PartnerMasterInput
  setFormField: Function
  inputError: InputErrorType
  setInputError: Function
}) => {
  let location = useLocation()
  const [salesManager, setSalesManager] = useState<SelectValueType[]>([])
  let {formField, setFormField, setInputError, inputError} = props

  return (
    <div className='row mb-3 justify-content-between'>
      <div className='col-md-6 px-8 mb-5 '>
        <CustomTextInput
          label='Company Name'
          value={formField.companyName}
          name='companyName'
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.companyName}
        />
      </div>
      <div className='col-md-6 px-8 mb-5 '>
        <CustomTextInput
          label='Contact Person Name'
          value={formField.partnerName}
          name='partnerName'
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.partnerName}
        />
      </div>

      <div className='col-md-6 px-8 mb-5 '>
        <CustomNumberInput
          label='Contact Person No'
          value={formField.contactNo}
          name='contactNo'
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.contactNo}
        />
      </div>
      <div className='col-md-6 px-8 mb-5 '>
        <CustomTextInput
          label='Email'
          name='email'
          value={formField.email}
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.email}
        />
      </div>

      <div className='col-md-6 px-8 mb-5 '>
        <CustomTextInput
          label='Address'
          name='address'
          value={formField.address}
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.address}
        />
      </div>

      <div className='col-md-6 px-8 mb-5 '>
        <CustomTextInput
          label='Pan No'
          value={formField.panNo?.toUpperCase()}
          name='panNo'
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.panNo}
        />
      </div>

      <div className='col-md-6 px-8 mb-5 '>
        <CustomFileInput
          label='Pan Document'
          name='panDoc'
          accept='image/png,image/jpeg,image/jpg,application/pdf'
          withAsterisk={false}
          value={formField.panDoc}
          onChange={(value) => {
            handleOtherInputChange(value, 'panDoc', setFormField, inputError, setInputError)
          }}
          error={inputError.panDoc}
        />
      </div>
      <div className='col-md-6 px-8 mb-5 '>
        <CustomTextInput
          label='Aadhar No'
          value={formField.aadharNo}
          name='aadharNo'
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.aadharNo}
        />
      </div>

      <div className='col-md-6 px-8 mb-5 '>
        <CustomFileInput
          label='Aadhar Document'
          value={formField.aadharDoc}
          withAsterisk={false}
          accept='image/png,image/jpeg,image/jpg,application/pdf'
          name='aadharDoc'
          onChange={(value) =>
            handleOtherInputChange(value, 'aadharDoc', setFormField, inputError, setInputError)
          }
          error={inputError.aadharDoc}
        />
      </div>
      <div className='col-md-6 px-8 mb-5 '>
        <CustomRadioInput
          label='GST Applicable'
          value={formField.gstApplicable}
          onChange={(value) => {
            clearInputError('gstApplicable', inputError, setInputError)
            clearInputError('gstReason', inputError, setInputError)
            clearInputError('gstDoc', inputError, setInputError)
            clearInputError('gstNo', inputError, setInputError)
            setFormField({...formField, gstApplicable: value, gstReason: '', gstDoc: '', gstNo: ''})
          }}
          data={[
            {label: 'Yes', value: 'true'},
            {label: 'No', value: 'false'},
          ]}
          error={inputError.gstApplicable}
          children={undefined}
        />
      </div>
      <div className='col-md-6 px-8 mb-5 ' hidden={formField.gstApplicable !== 'false'}>
        <CustomTextInput
          label='GSTIN Not Applicable Reason'
          value={formField.gstReason}
          name='gstReason'
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.gstReason}
        />
      </div>
      <div className='col-md-6 px-8 mb-5 ' hidden={formField.gstApplicable !== 'true'}>
        <CustomTextInput
          label='GSTIN No.'
          value={formField.gstNo}
          name='gstNo'
          onChange={(event) => handleInputChange(event, setFormField, inputError, setInputError)}
          error={inputError.gstNo}
        />
      </div>
      <div className='col-md-6 px-8 mb-5 ' hidden={formField.gstApplicable !== 'true'}>
        <CustomFileInput
          label='GSTIN Document'
          accept='image/png,image/jpeg,image/jpg,application/pdf'
          value={formField.gstDoc}
          name='gstDoc'
          withAsterisk={false}
          onChange={(value) =>
            handleOtherInputChange(value, 'gstDoc', setFormField, inputError, setInputError)
          }
          error={inputError.gstDoc}
        />
      </div>
    </div>
  )
}

export default PartnerForm
